<div class="step-container step-tema">
  <h2 class="step-titulo">Personalize seu cardapio</h2>
  <p class="step-subtitulo">Escolha uma paleta de cores para sua loja. Voce pode alterar depois.</p>

  <div class="tema-layout">
    <!-- Coluna esquerda: Controles -->
    <div class="tema-controles">
      <app-seletor-paletas
        [cores]="cores"
        (coresChange)="onCoresAlteradas($event)"
        (paletaSelecionadaChange)="onPaletaSelecionada($event)"
        (paletaHover)="onPaletaHover($event)">
      </app-seletor-paletas>

    </div>

    <!-- Coluna direita: Preview -->
    <div class="tema-preview-panel">
      <span class="preview-title">Preview em tempo real</span>
      <div class="phone-frame">
        <div class="phone-notch"></div>
        <div class="phone-screen">
          <iframe *ngIf="urlPreview"
                  #iframePreview
                  [src]="urlPreview"
                  class="preview-iframe"
                  frameborder="0"
                  scrolling="yes"
                  (load)="onIframeLoad()">
          </iframe>
          <div *ngIf="!urlPreview" class="no-preview">
            <i class="fe-eye-off" style="font-size: 32px; color: #ccc; margin-bottom: 8px;"></i>
            <p class="text-muted">Carregando preview...</p>
          </div>
        </div>
        <div class="phone-home-bar"></div>
      </div>
    </div>
  </div>

  <!-- Navegacao -->
  <div class="step-actions">
    <button class="btn-anterior" (click)="voltar()">
      <i class="fe-arrow-left mr-1"></i> Anterior
    </button>
    <div class="actions-direita">
      <button class="btn-pular" (click)="pular()">Pular este passo</button>
      <button class="btn-proximo" [disabled]="ativando" (click)="avancar()">
        <span *ngIf="!ativando">Proximo <i class="fe-arrow-right ml-1"></i></span>
        <span *ngIf="ativando">Aplicando...</span>
      </button>
    </div>
  </div>
</div>
